import { config } from 'app/config/config';

class NavigationService {
    public static readonly AUTH_CALLBACK: string = '/auth/callback';
    public static readonly LOGOUT: string = '/logout';
    public static readonly ORDER: string = '/order';
    public static readonly ERROR: string = '/error';
    public static readonly ERROR_NOT_AVAILABLE = '/not-available';
    public static readonly ERROR_SESSION_EXPIRED: string = '/session-expired';
    public static readonly CHOOSE_ACCOUNT: string = `${NavigationService.ORDER}/choose-account`;
    public static readonly CHOOSE_SERVICE_LOCATION: string = `${NavigationService.ORDER}/choose-service-location`;
    public static readonly ERROR_NO_SERVICE_LOCATION: string = `${NavigationService.ORDER}/no-service-location`;
    public static readonly ERROR_RESTRICTED_PURCHASE: string = `${NavigationService.ORDER}/restricted-purchase`;
    public static readonly HOUSING_SELECT: string = `${NavigationService.ORDER}/housing-select`;
    public static readonly ERROR_NO_ACTIVE_BROADBAND: string = `${NavigationService.ORDER}/no-broadband`;
    public static readonly ERROR_MULTIPLE_BROADBAND_OFFERS: string = `${NavigationService.ORDER}/multiple-broadband-offers`;
    public static readonly ERROR_CANNOT_ORDER_MORE: string = `${NavigationService.ORDER}/cannot-order-more`;
    public static readonly ERROR_HAS_INFLIGHT_ORDER: string = `${NavigationService.ORDER}/has-inflight-order`;
    public static readonly PRODUCT_NOT_AVAILABLE: string = `${NavigationService.ORDER}/not-available`;
    public static readonly PRODUCT_DETAILS: string = `${NavigationService.ORDER}/details`;
    public static readonly SUMMARY: string = `${NavigationService.ORDER}/summary`;
    public static readonly SUCCESS: string = `${NavigationService.ORDER}/success`;

    public readonly goToMyPages = (): void => {
        window.location.href = config.MY_PAGES_URL;
    };

    public readonly goToMainPage = (): void => {
        window.location.href = config.MAIN_PAGE_URL;
    };
}

const navigationService = new NavigationService();

export { navigationService, NavigationService };
